"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class SalesOrderSearchResponse extends common_1.PaginatedResponse {
}
exports.SalesOrderSearchResponse = SalesOrderSearchResponse;
//# sourceMappingURL=sales-order-search.response.js.map